import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import { Input } from '@/comps/primitives/input';
import { Button } from '@/comps/primitives/button';
import { useDialogActions } from '@/contexts/dialogs/hooks';
import { useForm } from '@tanstack/react-form';
import { z } from 'zod';
import { DialogContent, DialogDescription, DialogFooter, DialogTitle } from '@/comps/primitives/dialog';
type Props = {
  reason: string;
  onSubmit: (value: string) => void;
};
export function ReasonDialogContent(t0) {
  const $ = _c(26);
  const {
    reason,
    onSubmit
  } = t0;
  const {
    close
  } = useDialogActions();
  let t1;
  if ($[0] !== close || $[1] !== onSubmit) {
    t1 = newReason => {
      onSubmit(newReason);
      close();
    };
    $[0] = close;
    $[1] = onSubmit;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleSubmit = t1;
  let t2;
  if ($[3] !== reason) {
    t2 = {
      reason
    };
    $[3] = reason;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      onChange: z.object({
        reason: z.string()
      })
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleSubmit) {
    t4 = t5 => {
      const {
        value: formValue
      } = t5;
      const {
        reason: reason_0
      } = formValue;
      handleSubmit(reason_0);
    };
    $[6] = handleSubmit;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = {
      defaultValues: t2,
      validators: t3,
      onSubmit: t4
    };
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const form = useForm(t5);
  let t6;
  if ($[11] !== form) {
    t6 = e => {
      e.preventDefault();
      form.handleSubmit();
    };
    $[11] = form;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <DialogTitle>Reason</DialogTitle>;
    t8 = <DialogDescription>please provide a reason to continue.</DialogDescription>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  let t9;
  if ($[15] !== form.Field) {
    t9 = <form.Field name="reason">{_temp}</form.Field>;
    $[15] = form.Field;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== close) {
    t10 = form_0 => <><Button variant="outline" type="button" onClick={() => close()}>Cancel</Button><Button type="submit" disabled={!form_0.values.reason}>Submit</Button></>;
    $[17] = close;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== form.Subscribe || $[20] !== t10) {
    t11 = <DialogFooter><form.Subscribe>{t10}</form.Subscribe></DialogFooter>;
    $[19] = form.Subscribe;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t6 || $[24] !== t9) {
    t12 = <DialogContent><form className="flex flex-col gap-2" onSubmit={t6}>{t7}{t8}{t9}{t11}</form></DialogContent>;
    $[22] = t11;
    $[23] = t6;
    $[24] = t9;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}
function _temp(field) {
  return <Input value={field.state.value} onChange={ev => {
    const valueTrimmed = ev.target.value.trim();
    field.handleChange(valueTrimmed);
  }} required={true} placeholder="insert reason..." aria-label="Reason" />;
}